import { useState } from 'react';
import { formateNumber } from '../../../utils/date-utils/formatters';
import { handleTrack } from '../../../utils/tracker';
import { If } from '../../Atoms/Conditionals';
import { MarktechModal } from '../../Atoms/Modal';
import { ButtonWithAnchor } from '../../income-tax/page-sections/hero-section/sticky-button';
import { Calculation } from '../calculation';
import {
  AtcRegimeDataMap,
  AtcRegimeMap,
  CALCULATOR_TAB_PROPS_ATC,
} from '../types';
import AtcTaxSummary from './atc-tax-summary';

export const AtcTaxCalculation = ({
  taxCalculation,
  activeTab,
}: CALCULATOR_TAB_PROPS_ATC) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const togglePlanModal = () => setIsPopupVisible(!isPopupVisible);
  const newRegimeTaxDue =
    taxCalculation?.['newRegimeCalculations'].totalAdvanceTaxDue;
  const oldRegimeTaxDue =
    taxCalculation?.['oldRegimeCalculations'].totalAdvanceTaxDue;
  const regime = AtcRegimeMap[activeTab || 0];
  const regimeData =
    regime && taxCalculation?.[regime as keyof AtcRegimeDataMap];

  if (!regimeData) {
    return <></>;
  }
  const { totalAdvanceTaxPaid } = taxCalculation;
  const { totalAdvanceTaxDue, currentPayable, netTaxLiability } = regimeData;
  const lastDateOfCurrentQuarter = taxCalculation.lastDateOfCurrentQuarter;
  const suggestedTaxScheme =
    taxCalculation.preferredRegime === 'New Regime'
      ? 'New Tax Regime'
      : 'Old Tax Regime';

  const newRegimeResults = taxCalculation.newRegimeCalculations;
  const oldRegimeResults = taxCalculation.oldRegimeCalculations;

  const taxDifference = Math.abs(
    Number(taxCalculation.newRegimeCalculations.netTaxLiability) -
      Number(taxCalculation.oldRegimeCalculations.netTaxLiability)
  );

  return (
    <div className="max-w-[651px] w-full relative top-[-60px] sm:flex sm:flex-col sm:items-center sm:top-5">
      <If condition={true}>
        <div className="mb-6 py-[10px] pl-4 rounded-md bg-grey-150 ">
          <div className="flex">
            <img
              className="w-6 h-6 mr-[14px]"
              src="https://assets.clear.in/cleartax/images/1721992734_bulb1.png"
              alt="bulb"
            />
            <p className="text-green-400 text-base font-medium sm:pb-[6px] sm:text-s-12">
              Switching to the{' '}
              <span className="font-bold sm:text-s-12">
                {suggestedTaxScheme}
              </span>{' '}
              would save you {formateNumber(taxDifference)} in taxes.
            </p>
          </div>
          <div className="ml-10 text-base font-medium">
            <ButtonWithAnchor
              buttonText="View Summary  &#8594;"
              isStickyOnMobile={false}
              onClickHandler={() => {
                handleTrack({ label: 'View_sumary' });
                return togglePlanModal();
              }}
              trackLabel={`pricing-section`}
              className="bg-transparent p-0 text-blue-350 font-medium sm:text-s-12"
            />
            <MarktechModal
              open={isPopupVisible}
              onClose={togglePlanModal}
              closeIcon={'✕'}
              classNames={{
                modal:
                  'w-10/12 mobile-search-box rounded-2xl md:w-11/12 sm:w-[95%] h-fit max-h-[90vh] overflow-hidden maxWidth',
                closeIcon: 'absolute',
              }}
              center
            >
              <AtcTaxSummary
                newRegimeResults={newRegimeResults}
                oldRegimeResults={oldRegimeResults}
                oldRegimeTaxDue={oldRegimeTaxDue || ''}
                newRegimeTaxDue={newRegimeTaxDue || ''}
              />
            </MarktechModal>
          </div>
        </div>
      </If>
      <div className="grid grid-cols-2 grid-rows-2 gap-6 md:gap-4 sm:gap-4  sm:grid-rows-1 sm:grid-cols-1 sm:mb-4 sm:w-full">
        <div className="calculation-card px-7  py-7 sm:py-3  md:px-2 bg-[#D0E4FE33] rounded-md text-center flex items-center justify-center">
          <Calculation
            title="Total advance tax due"
            counter={parseInt(totalAdvanceTaxDue)}
            classes="sm:text-s-24"
          />
        </div>
        <div className="calculation-card px-7 sm:px-14 py-7 sm:py-3 md:px-2 bg-[#D0E4FE33] rounded-md text-center">
          <Calculation
            title="Advanced tax payable"
            counter={parseInt(currentPayable)}
            classes="sm:text-s-32 text-s-32 font-bold pt-1 leading-[36px]"
            headerClasses="leading-[24px] font-bold"
          />
          <div className="text-s-14 font-medium">
            Due by {lastDateOfCurrentQuarter}
          </div>
        </div>
        <div className="calculation-card px-7 py-7 sm:py-3 md:py-8 md:px-2 sm:px-6 bg-[#D0E4FE33] rounded-md text-center flex items-center justify-center">
          <Calculation
            title="Advanced tax paid"
            counter={parseInt(totalAdvanceTaxPaid)}
            classes="sm:text-s-24"
          />
        </div>
        <div className="calculation-card px-7 py-7 sm:py-3 md:py-8 md:px-2 sm:px-6 bg-[#D0E4FE33] rounded-md text-center flex items-center justify-center">
          <Calculation
            title="Tax payable"
            counter={parseInt(netTaxLiability)}
            classes="sm:text-s-24"
          />
        </div>
      </div>
      <div className="bg-grey-150 mt-6 p-3 rounded-md text-s-14 sm:text-s-12 font-medium sm:mt-6">
        <div>
          Above advance tax is calculated @ 75% of your net tax liability minus
          total tax already paid
        </div>
        <div className="mt-3  sm:text-s-12 text-s-14 font-medium">
          {' '}
          Your net tax liability is ₹{netTaxLiability}.
        </div>
      </div>
    </div>
  );
};
